import { Music, Video, Image as ImageIcon } from "lucide-react";
import { useT } from "@/lib/i18n";

export const MEDIA_OPTIONS = [
  { key: "music", icon: Music },
  { key: "music_photo", icon: ImageIcon },
  { key: "video", icon: Video },
];

export const MediaRequirements = () => {
  const { t } = useT();
  return (
    <details className="rounded-xl bg-[#0B132B] border border-white/5 p-4 text-xs text-slate-400" data-testid="signup-requirements">
      <summary className="cursor-pointer text-blue-300 font-semibold text-sm">{t("req.title")}</summary>
      <div className="grid sm:grid-cols-3 gap-4 mt-3 leading-relaxed">
        <div><b className="text-slate-200">{t("req.videoL")}:</b> {t("req.video")}</div>
        <div><b className="text-slate-200">{t("req.audioL")}:</b> {t("req.audio")}</div>
        <div><b className="text-slate-200">{t("req.photoL")}:</b> {t("req.photo")}</div>
      </div>
    </details>
  );
};
